import React from "react";
import Breadcrumb from "./Breadcrumb";
import { Link } from "react-router-dom";
import EmersonHeader from "../components/header/EmersonHeader";
import "./AboutUs.css";
import FooterTwo from "../components/footer/FooterTwo";

function AboutUs() {
  const breadcrumbs = [{ label: "Home", link: "/" }, { label: "About Us" }];

  return (
    <div className="about-us-wrapper">
      <EmersonHeader />
      <Breadcrumb
        title="About Us"
        breadcrumbs={breadcrumbs}
        breadcrumbBg="/assets/images/breadcrumb/AboutUsBanner.jpg"
      />

      {/* Company Overview Section */}
      <div className="rts-about-area rts-section-gap about-company-section">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6">
              <div className="about-image-v-inner">
                <div className="image-area">
                  <img
                    className="mt--110 img-1"
                    src="assets/images/about/main/1.jpg"
                    alt="Sembian Engineering"
                  />
                  <img
                    className="img-over"
                    src="assets/images/about/main/2.jpg"
                    alt="Sembian Engineering"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about-progress-inner">
                <div className="title-area">
                  <span>Company Overview</span>
                  <h2 className="title">About Us</h2>
                </div>
                <div className="inner">
                  <p className="disc" style={{ textAlign: "justify" }}>
                    Founded in 2019, Sembian Research & Engineering Pvt. Ltd. is
                    a research and engineering company specializing in
                    Measurement & Analytical Systems, Instrumentation, Green
                    Hydrogen, Automation, Renewable Energies, Aerospace, and
                    Marine Technologies.
                  </p>
                  <p className="disc" style={{ textAlign: "justify" }}>
                    We blend deep domain expertise with cross-disciplinary
                    engineering to deliver end-to-end solutions - from concept
                    design to commissioning - empowering industries to operate
                    smarter, safer, and more sustainably.
                  </p>
                  <div
                    style={{
                      marginTop: "30px",
                      marginBottom: "30px",
                      padding: "25px 0",
                      borderTop: "2px solid #DF0A0A",
                      borderBottom: "2px solid #DF0A0A",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "16px",
                        fontStyle: "italic",
                        color: "#666",
                        margin: 0,
                        textAlign: "center",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "20px",
                          fontWeight: "bold",
                          color: "#DF0A0A",
                        }}
                      >
                        “
                      </span>
                      Very strong & highly specialized suppliers network,
                      competent and skillful workforce, excellent logistics,
                      subject expert availability.
                      <span
                        style={{
                          fontSize: "20px",
                          fontWeight: "bold",
                          color: "#DF0A0A",
                        }}
                      >
                        ”
                      </span>
                    </p>
                  </div>
                  <Link to={"/contactus"} className="rts-btn btn-primary">
                    Get In Touch
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Vision, Mission Section */}
      <div
        className="rts-service-area rts-section-gapBottom bg-light"
        style={{ paddingTop: "70px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="rts-title-area text-center mb--60 section-title-modern fade-in-up">
                <p
                  className="brand-promise-tagline"
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#DF0A0A",
                    marginBottom: "15px",
                  }}
                >
                  Our Foundation
                </p>
                <h2 className="title">Vision & Mission</h2>
              </div>
            </div>
          </div>
          <div className="row g-4">
            <div className="col-lg-6 col-md-6 col-sm-12 fade-in-up stagger-1">
              <div className="vision-mission-card">
                <div className="content">
                  <h5 className="title">Vision</h5>
                  <p className="disc" style={{ textAlign: "justify" }}>
                    Enable industries to transition into clean, intelligent, and
                    efficient operations through advanced engineering and
                    innovation.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 fade-in-up stagger-2">
              <div className="vision-mission-card">
                <div className="content">
                  <h5 className="title">Mission</h5>
                  <p className="disc" style={{ textAlign: "justify" }}>
                    Deliver world-class solutions in process analytics,
                    industrial automation, hydrogen, and clean technologies with
                    reliability, safety, and sustainability at the core.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Core Values Section */}
      <div className="rts-about-area rts-section-gap core-values-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="rts-title-area text-center section-title-modern fade-in-up">
                <p
                  className="brand-promise-tagline"
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#DF0A0A",
                    marginBottom: "15px",
                  }}
                >
                  Our Values
                </p>
                <h2 className="title">Core Values</h2>
              </div>
            </div>
          </div>
          <div className="row ">
            <div className="col-lg-12">
              <div className="rts-title-area text-center mb--60 section-title-modern fade-in-up">
                {/* <div className="col-lg-4 col-md-6 col-sm-12 fade-in-up stagger-1">
                            <div className="core-value-item">
                                <div className="core-value-icon">
                                    <i className="fas fa-shield-alt"></i>
                                </div>
                                <h6 className="title">Integrity</h6>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 fade-in-up stagger-2">
                            <div className="core-value-item">
                                <div className="core-value-icon">
                                    <i className="fas fa-shield-check"></i>
                                </div>
                                <h6 className="title">Safety</h6>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 fade-in-up stagger-3">
                            <div className="core-value-item">
                                <div className="core-value-icon">
                                    <i className="fas fa-lightbulb"></i>
                                </div>
                                <h6 className="title">Innovation</h6>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 fade-in-up stagger-4">
                            <div className="core-value-item">
                                <div className="core-value-icon">
                                    <i className="fas fa-check-double"></i>
                                </div>
                                <h6 className="title">Reliability</h6>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 fade-in-up stagger-5">
                            <div className="core-value-item">
                                <div className="core-value-icon">
                                    <i className="fas fa-leaf"></i>
                                </div>
                                <h6 className="title">Sustainability</h6>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 fade-in-up stagger-6">
                            <div className="core-value-item">
                                <div className="core-value-icon">
                                    <i className="fas fa-handshake"></i>
                                </div>
                                <h6 className="title">Collaboration</h6>
                            </div>
                        </div> */}
                <img
                  src="assets/images/sembiancore.png"
                  alt="Core Values"
                  style={{ width: "50%", height: "auto" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Brand Promise & Pillars Section */}
      <div className="rts-about-area rts-section-gap brand-promise-section">
        <div className="container">
          <div className="row g-5 align-items-start">
            <div className="col-lg-12 col-md-12 fade-in-up">
              <div className="title-area text-center">
                <p
                  className="brand-promise-tagline"
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#DF0A0A",
                    marginBottom: "15px",
                  }}
                >
                  Engineering for life
                </p>
                <h2 className="title mb--20">
                  Engineering Trust. Powering Tomorrow
                </h2>

                <p
                  className="disc"
                  style={{
                    lineHeight: "1.7",
                    maxWidth: "800px",
                    margin: "0 auto",
                  }}
                >
                  Our commitment to delivering world-class engineering solutions
                  that industries can trust, while powering a sustainable and
                  intelligent tomorrow through innovation and excellence.
                </p>
              </div>
            </div>
          </div>
          <div className="row g-5 mt--30">
            <div className="col-lg-12 col-md-12 fade-in-up stagger-1">
              <div className="title-area text-center">
                <h2 className="title mb--30">Brand Pillars</h2>
                <div className="row g-3 justify-content-center">
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <div
                      className="brand-pillar-item"
                      style={{
                        padding: "20px",
                        background: "#f6f6f6",
                        borderRadius: "8px",
                      }}
                    >
                      <h6
                        className="title"
                        style={{
                          fontSize: "15px",
                          fontWeight: "600",
                          margin: "0",
                        }}
                      >
                        Technical Excellence
                      </h6>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <div
                      className="brand-pillar-item"
                      style={{
                        padding: "20px",
                        background: "#f6f6f6",
                        borderRadius: "8px",
                      }}
                    >
                      <h6
                        className="title"
                        style={{
                          fontSize: "15px",
                          fontWeight: "600",
                          margin: "0",
                        }}
                      >
                        Innovation and R&D
                      </h6>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <div
                      className="brand-pillar-item"
                      style={{
                        padding: "20px",
                        background: "#f6f6f6",
                        borderRadius: "8px",
                      }}
                    >
                      <h6
                        className="title"
                        style={{
                          fontSize: "15px",
                          fontWeight: "600",
                          margin: "0",
                        }}
                      >
                        Sustainability
                      </h6>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <div
                      className="brand-pillar-item"
                      style={{
                        padding: "20px",
                        background: "#f6f6f6",
                        borderRadius: "8px",
                      }}
                    >
                      <h6
                        className="title"
                        style={{
                          fontSize: "15px",
                          fontWeight: "600",
                          margin: "0",
                        }}
                      >
                        Customer Partnership
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Leadership Section */}
      <div className="rts-about-area rts-section-gap leadership-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="rts-title-area text-center mb--60 section-title-modern fade-in-up">
                <p
                  className="brand-promise-tagline"
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#DF0A0A",
                    marginBottom: "15px",
                  }}
                >
                  Leadership
                </p>
                <h2 className="title">Our Leadership</h2>
              </div>
            </div>
          </div>
          <div className="row g-5 align-items-center">
            <div className="col-lg-4 col-md-5 col-sm-12 fade-in-up">
              <div className="leadership-image-wrapper">
                <img src="assets/images/senthil.jpg" alt="Senthil Natarajan" />
              </div>
            </div>
            <div className="col-lg-8 col-md-7 col-sm-12 fade-in-up stagger-1">
              <div className="about-progress-inner">
                <div className="title-area">
                  <h2 className="title mb--20">
                    <a style={{ color: "#DF0A0A", fontWeight: "700" }}>
                      Senthil
                    </a>{" "}
                    Natarajan
                  </h2>
                  <p
                    className="disc mb--30"
                    style={{
                      fontSize: "18px",
                      color: "#666",
                      fontWeight: "500",
                    }}
                  >
                    Founder & Managing Director, Sembian Research & Engineering
                    Pvt. Ltd.
                  </p>
                </div>
                <div className="inner">
                  <p className="disc mb--20" style={{ textAlign: "justify" }}>
                    A seasoned Process Analyser Systems Specialist, Senthil
                    Natarajan brings over 25+ years of global experience across
                    CSIR-CECRI, Emerson Automation Solutions, and ABB India Ltd.
                  </p>
                  <p className="disc mb--20" style={{ textAlign: "justify" }}>
                    His expertise spans R&D, Upstream–Midstream–Downstream
                    Process Analytics, CEMS, SWAS, and Green Hydrogen BoP. He
                    has led multi-million-dollar greenfield projects across
                    Asia-Pacific, North America, Europe, Russia, the Middle
                    East, and Africa, serving EPCs, OEMs, and End Users.
                  </p>
                  <div
                    className="leadership-quote"
                    style={{
                      marginTop: "30px",
                      marginBottom: "30px",
                      padding: "25px",
                      background: "#f8f9fa",
                      borderRadius: "8px",
                      borderLeft: "4px solid #DF0A0A",
                    }}
                  >
                    <p
                      className="disc"
                      style={{
                        textAlign: "justify",
                        fontStyle: "italic",
                        marginBottom: "15px",
                      }}
                    >
                      "My experience sits at the intersection of technology,
                      application, and commercialization - where technology
                      moves from lab prototypes to field-proven engineered
                      systems. Having led analyser system integration, hydrogen
                      BoP design, and automation projects globally, I understand
                      both the physics behind technology and the business behind
                      scaling it."
                    </p>
                    <p
                      className="disc mt--10"
                      style={{
                        fontWeight: "600",
                        color: "#000",
                        margin: 0,
                        fontFamily: "Lavishly Yours",
                      }}
                    >
                      — Senthil Natarajan
                    </p>
                  </div>
                  <div
                    style={{
                      marginTop: "30px",
                      padding: "20px",
                      background: "#fff",
                      borderRadius: "8px",
                      border: "1px solid #e8eaed",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "16px",
                        fontStyle: "italic",
                        color: "#666",
                        margin: 0,
                        textAlign: "center",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "20px",
                          fontWeight: "bold",
                          color: "#DF0A0A",
                        }}
                      >
                        “
                      </span>
                      Bringing smiles on others is the best gift we can have.
                      <span
                        style={{
                          fontSize: "20px",
                          fontWeight: "bold",
                          color: "#DF0A0A",
                        }}
                      >
                        ”
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Expertise Section */}
      <div className="rts-about-area rts-section-gap expertise-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="rts-title-area text-center mb--60 section-title-modern fade-in-up">
                <p
                  className="brand-promise-tagline"
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#DF0A0A",
                    marginBottom: "15px",
                  }}
                >
                  Expertise
                </p>
                <h2 className="title">Key Expertise Areas</h2>
              </div>
            </div>
          </div>
          <div className="row g-4">
            <div className="col-md-6 col-sm-12 fade-in-up stagger-1">
              <div className="expertise-card">
                <h6 className="title">Global Project Management</h6>
                <p className="disc">
                  Delivered complex greenfield automation and analyser projects
                  across continents, compliant with IEC, ATEX, NEC, and API
                  standards.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-sm-12 fade-in-up stagger-2">
              <div className="expertise-card">
                <h6 className="title">Multi-disciplinary Systems Thinking</h6>
                <p className="disc">
                  Combines electrical, electronics, mechanical, and materials
                  expertise with an MBA in International Business.
                </p>
              </div>
            </div>
            <div className="col-md-12 col-sm-12 fade-in-up stagger-3">
              <div className="expertise-card">
                <h6 className="title">Cross-Domain Integration</h6>
                <p className="disc">
                  Deep integration experience across PLC/DCS/SCADA, analysers,
                  and digital systems.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="rts-service-area rts-section-gapBottom">
        <div className="container">
          <div className="row">
            <div className="cta-one-bg col-12">
              <div className="cta-one-inner">
                <div className="cta-left">
                  <h3 className="title animated fadeIn">
                    Let's discuss how we can help make your business better
                  </h3>
                </div>
                <div className="cta-right">
                  <Link className="rts-btn btn-white" to={"/contactus"}>
                    Get In Touch
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FooterTwo />
    </div>
  );
}

export default AboutUs;
